module.exports = __webpack_public_path__ + "static-portal/img/19-1.5e29569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/19-1.jpg
// module id = gyE2
// module chunks = 4